import { memo } from "react";

function CustomerLocationMarker(props) {
  return (
    <svg
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: "scale(2.0)" }}
    >
      <g filter="url(#filter0_d)">
        <path
          d="M12.5 19.6667L11.7579 20.337C11.9475 20.5469 12.2171 20.6667 12.5 20.6667C12.7829 20.6667 13.0525 20.5469 13.2421 20.337L12.5 19.6667ZM12.5 19.6667C13.2421 20.337 13.2422 20.3368 13.2424 20.3366L13.2428 20.3362L13.2438 20.335L13.2473 20.3312L13.2591 20.318L13.3019 20.2698C13.3386 20.2282 13.3915 20.1679 13.4581 20.0905C13.5913 19.9359 13.78 19.7129 14.0056 19.4349C14.456 18.8799 15.0582 18.1005 15.6623 17.2051C16.2645 16.3126 16.8811 15.2865 17.3501 14.2396C17.8133 13.2057 18.1667 12.0773 18.1667 11C18.1667 7.86771 15.6323 5.33333 12.5 5.33333C9.36771 5.33333 6.83333 7.86771 6.83333 11C6.83333 12.0773 7.18672 13.2057 7.64989 14.2396C8.11893 15.2865 8.73548 16.3126 9.3377 17.2051C9.94183 18.1005 10.544 18.8799 10.9944 19.4349C11.22 19.7129 11.4087 19.9359 11.5419 20.0905C11.6085 20.1679 11.6613 20.2282 11.6981 20.2698L11.7409 20.318L11.7527 20.3312L11.7562 20.335L11.7572 20.3362L11.7576 20.3366C11.7578 20.3368 11.7579 20.337 12.5 19.6667ZM12.5 11.6667C12.1323 11.6667 11.8333 11.3677 11.8333 11C11.8333 10.6323 12.1323 10.3333 12.5 10.3333C12.8677 10.3333 13.1667 10.6323 13.1667 11C13.1667 11.3677 12.8677 11.6667 12.5 11.6667Z"
          fill={props.backgroundColor}
          stroke={props.borderColor || "white"}
          strokeWidth={props.strokeWidth || "2"}
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d"
          x="0.5"
          y="0.333332"
          width="24"
          height="25.3333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default (memo(CustomerLocationMarker));
